var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"content"},[_c('v-tooltip',{attrs:{"disabled":!_vm.value,"open-delay":300,"max-width":"250px","top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_c('Truncate',{attrs:{"content":_vm.value}})],1)]}}])},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }